var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-wrap"},[_c('div',{staticClass:"block-header"},[_c('span',{staticClass:"block-title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("after-title")],2),_c('div',{staticClass:"block-body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }